import { render, staticRenderFns } from "./SvgShape.vue?vue&type=template&id=4e2a1dac&"
import script from "./SvgShape.vue?vue&type=script&lang=js&"
export * from "./SvgShape.vue?vue&type=script&lang=js&"
import style0 from "./SvgShape.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports